const buttonSX = {
    backgroundColor: "#3834DC",
  textTransform: "none",
  borderRadius: "10px",
  fontWeight: "600",
  fontSize: "1.1rem",
    "&:hover": {
      backgroundColor: "rgb(56, 52, 220, 0.85)",
    },
  };

  export default buttonSX